import moment from "moment"

export const options = (data: any, time: any, height: any, fontSizeLabel: any, FilterLabel: any) => {
  const totalLength = data?.tradingDates ? parseInt(((data?.tradingDates.length / 10).toString())) : 0
  const listDataP = data?.pe || data?.pb

  let minPrice = data?.price?.[0]
  let maxPrice = 0
  if (data?.price) {
    data?.price.map((item: any) => {
      if (item < minPrice || !minPrice) {
        minPrice = item
      }
      if (item > maxPrice) {
        maxPrice = item
      }
    })
  }

  let minPE = listDataP?.[0]
  let maxPE = 0
  if (listDataP) {
    listDataP.map((item: any) => {
      if (item < minPE || !minPE) {
        minPE = item
      }
      if (item > maxPE) {
        maxPE = item
      }
    })
  }

  const series: any = []

  if (FilterLabel.length === 0 || FilterLabel.indexOf('Giá cổ phiếu') > -1) {
    series.push({
      name: 'Giá cổ phiếu',
      data: data?.price,
      color: '#29b638',
      lineColor: '#29b638',
      yAxis: 0,
      fillColor: {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 1
        },
        stops: [
          [0, '#29b63850'],
          [1, 'transparent']
        ]
      },
      marker: {
        radius: 0,
        lineColor: '#ffffff',
        fillColor: '#29b638',
        states: {
          hover: {
            radius: 8
          }
        }
      },
      borderWidth: 0
    })
  }

  if (FilterLabel.length === 0 || FilterLabel.indexOf('P/E') > -1) {
    series.push({
      name: 'P/E',
      data: listDataP,
      color: '#F7931A',
      lineColor: '#F7931A',
      yAxis: 1,
      fillColor: {
        linearGradient: {
          x1: 0,
          y1: 0,
          x2: 0,
          y2: 1
        },
        stops: [
          [0, '#F7931A50'],
          [1, 'transparent']
        ]
      },
      marker: {
        radius: 0,
        lineColor: '#ffffff',
        fillColor: '#F7931A',
        states: {
          hover: {
            radius: 8
          }
        }
      },
      borderWidth: 0,
    })
  }

  return {
    chart: {
      type: 'areaspline',
      backgroundColor: 'transparent',
      height: height,
    },
    title: {
      text: ''
    },
    xAxis: {
      categories: data?.tradingDates,
      tickInterval: totalLength,
      labels: {
        style: {
          color: '#ffffff',
          fontSize: fontSizeLabel
        },
        formatter: function (item: any) {
          let date = ''
          if (time === '1M' || time === '3M') {
            date = moment(item?.value, 'DD/MM/YYYY').format('DD/MM')
          } else {
            date = moment(item?.value, 'DD/MM/YYYY').format('MM/YYYY')
          }
          return date
        }
      },
      title: {
        text: ''
      },
      tickLength: 0,
      gridLineWidth: 0,
      lineWidth: 0,
      crosshair: {
        color: '#ff0000',
        dashStyle: 'Solid',
        snap: true,
        width: 2,
        className: 'esrpuelfux'
      }
    },
    yAxis: [{
      min: minPrice,
      max: maxPrice,
      tickLength: 0,
      gridLineWidth: 0,
      minorGridLineWidth: 0,
      lineWidth: 0,
      title: {
        text: '',
        style: {
          color: '#ffffff',
        }
      },
      labels: {
        x: -2,
        distance: 0,
        style: {
          color: '#ffffff',
          fontSize: fontSizeLabel
        },
        formatter: function (res: any) {
          return res?.value.toFixed(2);
        }
      },
    },
    {
      min: minPE,
      max: maxPE,
      tickLength: 0,
      gridLineWidth: 0,
      lineWidth: 0,
      opposite: true,
      title: {
        text: '',
        style: {
          color: '#ffffff'
        }
      },
      labels: {
        x: 0,
        enabled: true,
        style: {
          color: '#ffffff',
          fontSize: fontSizeLabel
        },
        formatter: function (res: any) {
          return res?.value.toFixed(2);
        }
      }
    }],
    legend: {
      enabled: false,
      itemStyle: {
        color: '#ffffff'
      }
    },
    plotOptions: {
      areaspline: {

      },
      series: {
        states: {
          inactive: {
            opacity: 1
          }
        }
      }
    },
    tooltip: {
      enabled: true,
      useHTML: true,
      split: true,
      borderRadius: 0,
      borderWidth: 0,
      backgroundColor: '#131313',
      formatter: function (item: any) {
        const thisData: any = this
        const index: any = thisData?.points?.[0]?.point?.index

        return `<div class="ioalomryco">
        <div class="fzlgnzcgwl whlqpruvka">${data?.tradingDates?.[index]}</div>
        <div class="fzlgnzcgwl fzbjtfpdgt">${data?.pb ? 'P/B' : ''}${data?.pe ? 'P/E' : ''}: ${listDataP?.[index].toFixed(2)}</div>
        <div class="fzlgnzcgwl fzbjtfpdgt">Giá cổ phiếu: ${data?.price?.[index].toFixed(2)}</div>
        </div>`;
      }
    },
    series: series
  }
}